import { partialGermanDateFormat } from '@pkg/form/utils/partialGermanDateFormat'
import dayjs from 'dayjs'
import { useEffect, useState } from 'react'
import { formatIsoToDe } from '../utils/formatIsoToDe'
import type { ISODate } from '../utils/parseDateInput'
import { parseDateInput } from '../utils/parseDateInput'
import { DateInputShell } from './DateInputShell'

export type DateInputProps = {
  value: ISODate | null | undefined
  onChange: (value: ISODate | null) => void
  placeholder?: string
  disabled?: boolean
  allowClear?: boolean
  status?: 'error' | 'warning'
  size?: 'small' | 'middle' | 'large'
  id?: string
  className?: string
}

export function DateInput(props: DateInputProps) {
  const { value, onChange, ...rest } = props
  const [text, setText] = useState(() => formatIsoToDe(value))
  const [error, setError] = useState(false)

  useEffect(() => {
    setText(formatIsoToDe(value))
    setError(false)
  }, [value])

  const commit = () => {
    const parsed = parseDateInput(text, { allowPartial: false })
    if (!parsed.ok && parsed.reason === 'empty') {
      setError(false)
      onChange(null)
      return
    }
    if (!parsed.ok) {
      setError(true)
      return
    }
    setError(false)
    setText(formatIsoToDe(parsed.value.from))
    onChange(parsed.value.from)
  }

  const revert = () => {
    setText(formatIsoToDe(value))
    setError(false)
  }

  return (
    <DateInputShell
      {...rest}
      text={text}
      onTextChange={next => {
        setText(partialGermanDateFormat(next))
        if (error) setError(false)
      }}
      allowClear
      onCommit={commit}
      onRevert={revert}
      error={error}
      popoverPicker="date"
      popoverValue={value ? dayjs(value, 'YYYY-MM-DD', true) : null}
      onPopoverChange={d => {
        if (!d) {
          setError(false)
          onChange(null)
          return
        }
        const iso = d.format('YYYY-MM-DD')
        setError(false)
        setText(formatIsoToDe(iso))
        onChange(iso)
      }}
    />
  )
}
